import React, { ChangeEvent, useState } from 'react'
import CustomInput from '../CustomInput'
import closeIcon from '../../assests/close.svg'
import CustomSelect from '../CustomSelect'
import CustomButton from '../CustomButton'
import { toast } from 'react-toastify'
import { ParseErrors } from '../../utils/ParseErrors'
import axiosInstance from '../../utils/axiosInstance'
import Loader from '../Loader'
import { User } from '../../providers/AuthProvider'
import GetUser from '../../utils/getUser'

interface TCreateAgentModel {
    ToggleModel: () => void,
    isEdit: User | boolean
}

let userTypes = [
    {
        label: "Super Admin",
        value: "super-admin",
    },
    {
        label: "Admin",
        value: "admin",
    },
    {
        label: "Agent",
        value: "agent",
    },
]

const CreateAgentModel = ({ ToggleModel, isEdit }: TCreateAgentModel) => {
    const user = GetUser()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [values, setValues] = useState<any>({})
    const isUpdate = typeof (isEdit) !== 'boolean' && isEdit?.id;


    // --------------------------------- [ CREATE USER ] --------------------------------
    const createUser = async () => {
        setIsLoading(true)
        try {
            const res = await axiosInstance.post('/auth/register', values)
            toast.success(res.data.message)
            setIsLoading(false)
            ToggleModel()
        } catch (error) {
            console.log(error)
            toast.error(ParseErrors(error))
            setIsLoading(false)
        }
    }


    // --------------------------------- [ CREATE USER ] --------------------------------
    const updateUser = async () => {
        setIsLoading(true)
        try {
            const res = await axiosInstance.put(`/user/update/${isUpdate && isEdit.id}`, values)
            toast.success(res.data.message)
            setIsLoading(false)
            ToggleModel()
        } catch (error) {
            console.log(error)
            toast.error(ParseErrors(error))
            setIsLoading(false)
        }
    }

    // ------------------------------ [ ON CHANGE VALUES ] --------------------------------
    const onChangeValues = (e: ChangeEvent<HTMLInputElement>) => {
        setValues((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }

    return (
        <div className=" z-[99999] w-full h-full fixed top-0 left-0 bg-black/60 backdrop-blur-sm flex items-center justify-center animate-fade-in">
            <div className="bg-surface border border-edge min-w-[450px] rounded-2xl shadow-overlay smallTablet:min-w-0 smallTablet:w-[calc(100vw-2rem)] smallTablet:max-w-[calc(100vw-2rem)] smallTablet:max-h-[90dvh] smallTablet:overflow-y-auto">
                {/*---------------------------- [ HEADER ] ------------------------------- */}
                <div className="flex items-center justify-between py-4 px-6 border-b border-edge-faint smallTablet:px-4">
                    <h2 className="font-heading-font text-[25px] smallTablet:text-[20px] bg-gradient-heading bg-clip-text text-transparent">{isUpdate ? "Update" : "Create"} User</h2>
                    <button onClick={ToggleModel}><img src={closeIcon} alt='Close Img' className='cover h-[32px] w-[32px] cursor-pointer' /></button>
                </div>
                {/*---------------------------- [ HEADER ] ------------------------------- */}

                {/* -------------------------- [ BODY ] ------------------------------------ */}
                <div className='p-8 smallTablet:p-4'>
                    <CustomInput autoComplete="none" label='Full Name' defaultValue={isUpdate ? isEdit?.name : ""} name='name' onChange={onChangeValues} />
                    <div className='my-4'></div>
                    <CustomInput autoComplete="none" label='Email' defaultValue={isUpdate ? isEdit?.email : ""} name='email' onChange={onChangeValues} />
                    <div className='my-4'></div>
                    <CustomInput autoComplete="none" label='Phone' defaultValue={isUpdate ? isEdit?.phone : ""} name='phone' onChange={onChangeValues} />
                    <div className='my-4'></div>
                    <CustomInput autoComplete="none" label='User Code' defaultValue={isUpdate ? isEdit?.code : ""} name='code' onChange={onChangeValues} />
                    <div className='my-4'></div>
                    {!isUpdate && <>
                        <CustomInput autoComplete="none" label='Password' name='password' onChange={onChangeValues} />
                        <div className='my-4'></div>
                    </>}
                    <CustomSelect comboboxType='select' label="User Type" labelProperty="label"
                        valueProperty="value" options={user.type === "super-admin" ? userTypes : userTypes.filter((userT) => userT.value !== "super-admin")}
                        onSingleSelectChange={(option) => setValues((prev) => ({ ...prev, type: option?.value }))}
                        value={userTypes.find((type) => type.value === (isUpdate ? isEdit?.type : values?.type))}
                    />
                    <div className='my-6'></div>
                    <CustomButton disabled={isLoading} fullWidth variant='primary' className='w-full' onClick={isUpdate ? updateUser : createUser}>
                        {isLoading ? <Loader /> : isUpdate ? "UPDATE" : "SUBMIT"}
                    </CustomButton>
                </div>
                {/* -------------------------- [ BODY ] ------------------------------------ */}
            </div>
        </div>
    )
}

export default CreateAgentModel
